var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pd-section"},[(_vm.title)?_c('header',{staticClass:"pd-section__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"pd-section__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }